"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBCalloutPopover = require("../HBCalloutPopover.styles");
var _colors = _interopRequireDefault(require("../../../styles/colors"));
var _Lightbulb = _interopRequireDefault(require("@honeybook/icons/dist/icons/Lightbulb24"));
var _HBCalloutPopoverActionsAndPagination = _interopRequireDefault(require("./HBCalloutPopoverActionsAndPagination"));
var _useBuildTestIdInternal = require("../../common/internal/useBuildTestIdInternal");
var _HBCloseButton = _interopRequireDefault(require("../../HBCloseButton/HBCloseButton"));
var _HBText = _interopRequireDefault(require("../../HBText/HBText"));
var _useWindowSize2 = require("../../common/useWindowSize");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _breakpoints = require("../../../styles/breakpoints");
var _CalloutMediaElement = _interopRequireDefault(require("../../common/Callout/CalloutMediaElement"));
var HBCalloutPopoverContent = function HBCalloutPopoverContent(_ref) {
  var _ref$calloutTheme = _ref.calloutTheme,
    calloutTheme = _ref$calloutTheme === void 0 ? 'neutral' : _ref$calloutTheme,
    _ref$primaryActionTyp = _ref.primaryActionType,
    primaryActionType = _ref$primaryActionTyp === void 0 ? 'button' : _ref$primaryActionTyp,
    onClose = _ref.onClose,
    children = _ref.children,
    testId = _ref.testId,
    testIdName = _ref.testIdName,
    actionsOrientation = _ref.actionsOrientation,
    title = _ref.title,
    description = _ref.description,
    mediaPath = _ref.mediaPath,
    actions = _ref.actions,
    stepsContent = _ref.stepsContent,
    _ref$withIcon = _ref.withIcon,
    withIcon = _ref$withIcon === void 0 ? true : _ref$withIcon,
    onImageClick = _ref.onImageClick;
  var primaryActionTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'primary-action',
    componentName: 'HBButton'
  });
  var secondaryActionTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'secondary-action',
    componentName: 'HBButton'
  });
  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
    isUpToSmall = _useWindowSize.isUpToSmall;
  var styles = (0, _HBCalloutPopover.getCalloutPopoverStyles)(isUpToSmall)[calloutTheme];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_HBCalloutPopover.Container, null, mediaPath && /*#__PURE__*/_react["default"].createElement(_HBCalloutPopover.MediaContainer, null, /*#__PURE__*/_react["default"].createElement(_CalloutMediaElement["default"], {
    withImagePadding: false,
    mediaPath: mediaPath,
    imageFit: 'cover',
    layout: 'center',
    width: '100%',
    onClick: onImageClick
  })), /*#__PURE__*/_react["default"].createElement(_HBCalloutPopover.IconAndTextContainer, null, withIcon && /*#__PURE__*/_react["default"].createElement(_Lightbulb["default"], {
    color: calloutTheme === 'neutral' ? _colors["default"].neutral900 : _colors["default"].white
  }), /*#__PURE__*/_react["default"].createElement(_HBCalloutPopover.TextContainer, null, title && /*#__PURE__*/_react["default"].createElement(_HBCalloutPopover.Title, {
    type: isUpToSmall ? 'display24' : 'emphasis16',
    color: styles.textColor,
    align: "left"
  }, title), /*#__PURE__*/_react["default"].createElement(BodyText, {
    type: isUpToSmall ? 'body18' : 'body14',
    color: styles.textColor,
    align: "left"
  }, description))), children && /*#__PURE__*/_react["default"].createElement("div", null, children), /*#__PURE__*/_react["default"].createElement(_HBCalloutPopoverActionsAndPagination["default"], {
    styles: styles,
    primaryActionType: primaryActionType,
    actions: actions,
    primaryActionTestId: primaryActionTestId,
    secondaryActionTestId: secondaryActionTestId,
    actionsOrientation: actionsOrientation,
    stepsContent: stepsContent
  })), onClose && /*#__PURE__*/_react["default"].createElement(_HBCloseButton["default"], {
    size: "xs",
    onClick: onClose,
    theme: styles.closeButtonTheme,
    distance: 8,
    testId: testId,
    testIdName: testIdName
  }));
};
var _default = exports["default"] = HBCalloutPopoverContent;
var BodyText = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBCalloutPopoverContent__BodyText",
  componentId: "sc-1mnsze8-0"
})(["", "{margin-left:-30px;}"], _breakpoints.upToSmall);
//# sourceMappingURL=HBCalloutPopoverContent.js.map